module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/6-1-f8b37d989e6578447c0dff27d3a413ff.jpg";